import { Component, EventEmitter, Output, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'jenz-button',
  imports: [ButtonModule, TranslateModule, TooltipModule],
  templateUrl: './jenz-button.html',
  styleUrl: './jenz-button.scss',
  standalone: true,
})
export class JenzButton {
  readonly type = input<'primary' | 'secondary' | 'transparent' | 'danger' | 'custom'>('primary');
  readonly size = input<'small' | 'large' | undefined>(undefined);
  readonly label = input('');
  readonly loading = input(false);
  readonly disabled = input(false);
  readonly icon = input('');
  readonly text = input(false);
  readonly customClass = input('');
  readonly buttonType = input('button');
  readonly isVisible = input(true);

  tooltip = input<string>('');
  tooltipPosition = input<'right' | 'top' | 'bottom' | 'left'>('top');

  @Output() onClick = new EventEmitter<MouseEvent>();

  get textValue() {
    return this.text() || this.type() === 'transparent';
  }

  click(event: MouseEvent) {
    this.onClick.emit(event);
  }
}
